<template>
    <div class="property-search-loading-state">
        <b-row
            no-gutters
            class="homes-number-placeholder"
        >
            <b-skeleton
                animation="wave"
                width="75%"
                height="2rem"
            />
        </b-row>
        <b-row
                no-gutters
        >
            <b-col
                v-for="index in numberOfCards"
                :key="index"
                cols="12"
                sm="6"
                md="12"
                lg="6"
                class="p-1 col-xxxl-4 col-xxxll-3"
            >
                <b-card
no-body
class="loading-property-card"
>
                    <b-row no-gutters>
                        <b-col>
                            <b-skeleton-img
height="9.375rem"
no-aspect
card-img="top"
animation="wave"
/>
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col
class="px-3 py-2"
cols="12"
>
                            <b-skeleton
animation="wave"
width="75%"
class="my-2"
/>
                            <b-skeleton
animation="wave"
width="75%"
class="my-2"
/>
                            <b-skeleton
animation="wave"
width="75%"
class="my-2"
/>
                        </b-col>
                    </b-row>
                    <b-row no-gutters>
                        <b-col>
                            <b-card-footer class="mb-0 d-flex align-items-center justify-center px-3">
                                <b-skeleton
animation="wave"
width="100%"
class="mb-0"
/>
                            </b-card-footer>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import './PropertySearchLoadingState.scss';

    const NUMBER_OF_LOADING_CARDS = 20;

    export default {
        name: 'PropertySearchLoadingState',
        data() {
            return {
                numberOfCards: NUMBER_OF_LOADING_CARDS,
            };
        },
    };
</script>
